<div class="popover-erreur-creation-compte-content">
  <p class="typo-18-green ion-text-center">
    La procédure du changement de mot de passe a expiré.
  </p>
</div>
